import React from "react"
import { Typography, withStyles } from '@material-ui/core';
import styles from "./style"
import Header from "./header"
import { getEventTemplateFields } from "relay/event"
import Loader from "storybookComponents/Loader";
import LeftMenu from "./leftMenu"
import { makeThankYouEmailTemplateEditable } from "../EditableTemplates/editThankYouEmail"
import updateEmailTemplate from "relay/event/mutations/updateEmailTemplate"
import MobilePreviewComponent from 'storybookComponents/MobilePreview/index';
import Button from "storybookComponents/Button"
import { parseStringToHtml, getEventImageUrl, parseBody } from "../utils"

const buttons = ['Desktop', 'Mobile', 'SMS']

var emailInput = {}

const Iframe = ({ classes, src }) => {
  React.useEffect(() => {
    const frame = document.getElementById("IframeEmail");
    if (!frame) return
    frame.onload = () => {
      frame.style.height =
        (frame.contentWindow.document.body.scrollHeight + 100) + 'px';
    }
  })

  return <iframe id="IframeEmail" className={classes.iframeBackground} width="843" srcDoc={src} />
}

const EditEmail = ({ classes, item, allEmails, toggleModal, orgColors, ...props }) => {
  const [templateDetails, setTemplateDetails] = React.useState()
  const [loading, setLoading] = React.useState(true);
  const [active, setActive] = React.useState("active")
  const [subject, setSubject] = React.useState(props.subject);
  const [view, setView] = React.useState('Desktop');
  const [body, setBody] = React.useState("")
  const [selectedItem, setSelectedItem] = React.useState(item)

  React.useEffect(() => {
    window.parent.emailEditorInputChange = (type, field, value) => {
      emailInput[field] = value;
      if (field === "confirmation_text") {
        emailInput.body_text = value;
      }
    }
  }, [1])

  const handleChangeInput = (evt) => {
    setSubject(evt.target.value)
    if (window.parent.emailEditorInputChange) {
      window.parent.emailEditorInputChange("", "subject", evt.target.value)
    }
  }

  const parseSendingPayLoad = (body) => {
    let _body = body.replace(/\<p><br><\/p>/g, "<br/>")
    _body = _body.replace(/\<p>/g, "")
    return _body.replace(/\<\/p>/g, "<br/>")
  }
  const updateFieldValue = (field, input) => {
    let value = ""
    if (field.field.endsWith("___subject_text___text"))
      value = input.subject_text;
    if (field.field.endsWith("___title_text___text"))
      value = input.title_text;
    if (field.field.endsWith("___subtitle_text___text"))
      value = input.subtitle_text;
    if (field.field.endsWith("___body_text___text") && input.body_text) {
      value = parseSendingPayLoad(input.body_text);
    }
    if (field.field.endsWith("___confirmation-text___text") && input.confirmation_text) {
      value = parseSendingPayLoad(input.confirmation_text);
    }
    if (field.field.endsWith("___schedule-text___text") && input.schedule_text) {
      value = input.schedule_text;
    }
    if (field.field.endsWith("___splash_image_large___img_src"))
      value = input.image_url;
    return value
  }


  const onEditEmail = async () => {
    try {
      setActive("inactive");
      if (templateDetails) {
        let fields = templateDetails.fields.map(i => ({
          ...i,
          value: updateFieldValue(i, emailInput)
        })).filter(i => i.value);
        let subject = emailInput.subject || templateDetails.subject

        let payload = {
          id: templateDetails.id,
          name: templateDetails.name,
          templateId: templateDetails.templateId,
          subject,
          fields: JSON.stringify(fields)
        }
        let localInvite = []
        const response = await updateEmailTemplate(payload);
        if (response && response.saveHyblastEditor) {
          templateDetails.fields.map((item) => {
            fields.map((field) => {
              if (item.field === field.field) {
                localInvite = localInvite.filter(i => i.field !== item.field)
                localInvite.push(field);
              } else {
                localInvite.push(item);
              }
            })
          })

          setTemplateDetails({ ...templateDetails, ...response.saveHyblastEditor.hyblastEditor, subject })

          let field = response.saveHyblastEditor.hyblastEditor.fields ? response.saveHyblastEditor.hyblastEditor.fields.find(field => field.field.endsWith("___confirmation-text___text") || field.field.endsWith("___body_text___text")) : ""
          if (field) {
            setBody(parseBody(field.value))
          }
          props.showNotification(`Email for ${selectedItem.emailName} is updated successfully.`)
        }
      }
      setActive("active");
    }
    catch (error) {
      setLoading(false)
      console.log("error : ", error)
      setActive("active");
    }

  }



  React.useEffect(() => {
    emailInput = {};
    loadTemplateDetails(item.email_id);
  }, [1])

  const loadTemplateDetails = async (emailId) => {
    try {
      setLoading(true)
      let hyblastEditorResponse = await getEventTemplateFields(emailId)
      if (hyblastEditorResponse && hyblastEditorResponse.hyblastEditor) {
        setTemplateDetails(hyblastEditorResponse.hyblastEditor)
        let field = hyblastEditorResponse.hyblastEditor.fields ? hyblastEditorResponse.hyblastEditor.fields.find(field => field.field.endsWith("___confirmation-text___text") || field.field.endsWith("___body_text___text")) : ""
        if (field) {
          setBody(parseBody(field.value))
        }
        setSubject(hyblastEditorResponse.hyblastEditor.subject)
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const handleSubMenuCallback = (item) => {
    loadTemplateDetails(item.email_id)
    setSelectedItem(item)
  }

  const handleClick = (item) => {
    setView(item)
  }

  const renderButtons = (item, index) => {
    return (
      <>
        <Button className={classes.rightButtonCSS} variant="tertiary" onClick={() => handleClick(item)}>
          <div className={`${view !== item && classes.inactiveCSS}`}>
            {item}
          </div>
        </Button>
        {index !== buttons.length - 1 && <div className={classes.separator} />}
      </>
    )
  }
  return (
    <div className={classes.root}>
      <Header item={selectedItem} toggleModal={toggleModal} {...props} classes={classes} onSave={onEditEmail} active={active} />
      <div className={classes.iframeContainer}>
        <LeftMenu selectedSubMenu={item.email_id} group={item.group} classes={classes} handleSubMenuCallback={handleSubMenuCallback} allEmails={allEmails} />
        {
          loading ? <div className={classes.loader}> <Loader /> </div> : view === "Desktop" ?
            <div>
              <div>
                <label className={classes.subjectLabel}>Subject</label>
                <div>
                  <input value={subject} onChange={handleChangeInput} style={{ width: props.dimesions, paddingLeft: 20 }} className={classes.subjectInput} />
                </div>
              </div>
              <Iframe
                classes={classes}
                src={makeThankYouEmailTemplateEditable(templateDetails.substitutedMacrosHtml, orgColors, body)}
              />
            </div> : view === "Mobile" ? <MobilePreviewComponent html={templateDetails.substitutedMacrosHtml} /> : <MobilePreviewComponent smsView html={`<div style="font-family:Open Sans, arial, sans-serif"><div><img style="width:100%; border-radius:10px;" src = "${getEventImageUrl(templateDetails.substitutedMacrosHtml)}"/></div><div style="background:#f9f9f9; padding:10px; margin-top:10px; border-radius:10px;">${parseStringToHtml(item.sms_body, orgColors)}</div></div>`} />
        }
        <div className={classes.rightButtonsContainer}>
          {
            buttons.map(renderButtons)
          }
        </div>


      </div>
    </div >
  )
}

export default withStyles(styles)(EditEmail);